module.exports = __webpack_public_path__ + "media/images/logos/University-of-Oxford-ca4450a54133e5ddbab142f07d7bd5af.svg";